export const SKELETON_TRANSITION_MS = 200;

export default {
  SKELETON_TRANSITION_MS,
};
